import { useState, useCallback, useMemo } from 'react';
import { useGetBuyManagersByIdQuery, useUpdateBuyManagerMutation } from '../services/buyManagersApi';
import { useDispatch, useSelector } from 'react-redux';
import { updateBuyManager, getBuyManagerById, getBuyManagerByEncoreHiveId } from '../store/slices/buyManager/buyManagers';

const useBuyManager = () => {
  const [buyManagerData, setBuyManagerData] = useState({
    buyManagerId: null,
    userId: null,
  });
  const dispatch = useDispatch();

  const { isLoading, isError, error } = useGetBuyManagersByIdQuery(
    { buyManagerID: buyManagerData.buyManagerId, encoreHiveId: buyManagerData.userId },
    {
      skip: !buyManagerData.buyManagerId && !buyManagerData.userId,
    }
  );

  const buyManager = useSelector(state => 
    buyManagerData.buyManagerId 
      ? getBuyManagerById(state, buyManagerData.buyManagerId)
      : getBuyManagerByEncoreHiveId(state, buyManagerData.userId)
  );

  const [updateBuyManagerMutation, { data:updatedBM, isLoading: isUpdating, isError: isUpdateError, error: updateError }] =
    useUpdateBuyManagerMutation();

  const getBuyManagerByUserId = useCallback((userId) => {
    setBuyManagerData({ ...buyManagerData, userId });
  }, [buyManagerData]);

  const getBuyManagerById = useCallback((buyManagerId) => {
    setBuyManagerData({ ...buyManagerData, buyManagerId });
  }, [buyManagerData]);

  const updateBuyManagerData = useCallback(async (updatedData) => {
    if (!buyManager) {
      console.error('No buy manager selected');
      return;
    }

    try {
      const result = await updateBuyManagerMutation({
        id: buyManager.buyManagerID,
        ...updatedData,
      }).unwrap();
      dispatch(updateBuyManager(result));
      return result;
    } catch (err) {
      console.error('Failed to update buy manager:', err);
      throw err;
    }
  }, [buyManager, updateBuyManagerMutation, dispatch]);

  return {
    buyManager,
    isLoading,
    isError,
    error,
    getBuyManagerByUserId,
    getBuyManagerById,
    updateBuyManagerData,
    updatedBM,
    isUpdating,
    isUpdateError,
    updateError,
  };
};

export default useBuyManager;
